import { inject } from '@angular/core';
import { CanActivateFn, GuardResult, Router } from '@angular/router';
import { UserService } from '../../services/user.service';

export const templateEditorGuard: CanActivateFn = async (): Promise<GuardResult> => {
  const router = inject(Router);
  const userService = inject(UserService);

  await userService.loadSubscriptionData();

  if (userService.isTemplateEditorAllowed()) {
    return true;
  }

  return router.createUrlTree(['/main/dashboard']);
};
